import { Box, Button, LinearProgress, Stack, TextField } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import WaiverTable from "./waiverTable";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { AuthRequest } from "../../../util/request/authRequest";
import { GetAll } from "../../../util/request/getAll";

const WaiverList = (props) => {
  const [datePick, setDatePick] = useState(dayjs());
  const [name, setName] = useState("");
  const [waiverData, setWaiverData] = useState([]);

  const numKid = waiverData.reduce((sum, obj) => sum + obj.minors.length, 0);

  useEffect(() => {
    async function runFunc() {
      const date = new Date(datePick);

      date.setDate(date.getDate() + 1);

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const endDate = `${year}-${month}-${day}`;

      const response = await GetAll({
        subLink: `waiver?timeStamp[gt]=${datePick
          .format("YYYY-MM-DD")
          .slice(0, 10)}T05:00:00.000Z&timeStamp[lt]=${endDate}T05:00:00.000Z
          `,
      });

      if (response.data) {
        const resultData = response.data.data.sort((a, b) =>
          b.timeStamp.localeCompare(a.timeStamp)
        );
        const filterData =
          resultData.length > 0 && name.length > 0
            ? resultData.filter((item) =>
                `${item.firstName.toLowerCase()}${item.lastName.toLowerCase()}`.includes(
                  name.toLowerCase()
                )
              )
            : response.data.data;
        setWaiverData(filterData);
      }
    }

    const timeoutId = setTimeout(() => {
      runFunc();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [datePick, name]);

  return (
    <Stack sx={{ width: "90vw" }}>
      <Stack direction="row" spacing={3} alignItems="center">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              slotProps={{
                actionBar: { actions: [] }, // Remove Cancel and OK buttons
              }}
              closeOnSelect // Automatically closes after a date is sele
              label="Signed Date From"
              defaultValue={dayjs()}
              value={datePick}
              onChange={(newValue) => {
                setDatePick(newValue);
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
        <TextField
          id="standard-basic"
          label="Name"
          variant="outlined"
          value={name}
          onChange={(event) => {
            setName(event.target.value);
          }}
          sx={{ pt: "8PX" }}
        />
        <></>
        {/* <Box sx={{ fontSize: "20px" }}>
          Total:<span styple={{ color: "green" }}>{waiverData.length}</span>
        </Box> */}
        <Button variant="contained" onClick={() => props.refreshData()}>
          Refresh
        </Button>
      </Stack>
      <Stack>
        {name.length === 0 && (
          <Stack
            height={"60px"}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              bgcolor: "#41d09769",
              maxHeight: `calc(100vh - 180px)`,
              maxWidth: "780px",
              mt: "10px",
              mb: "10px",
              borderRadius: "5PX",
              padding: "10px",
            }}
          >
            <Box sx={{ mr: "30px", fontSize: "18px" }}>Waiver count: </Box>
            <LinearProgress
              variant="determinate"
              value={(waiverData.length / 300) * 100}
              sx={{ width: "40vw" }}
            ></LinearProgress>
            <Box sx={{ fontSize: "18px", ml: "5px" }}>
              {waiverData.length} / 300
            </Box>
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                height: "70%",
                width: "80px",
                margin: "20px",
                bgcolor: "white",
                borderRadius: "10px",
                border: "3px solid white",
                textAlign: "center",
              }}
            >
              <Box>Minors:</Box>
              <Box sx={{ color: "green", fontSize: "20px" }}>{numKid}</Box>
            </Stack>
          </Stack>
        )}
        <WaiverTable waiverData={waiverData} />
      </Stack>
    </Stack>
  );
};

export default WaiverList;
